import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/properties/components/selectedValue/SelectedValue.less');
const cx = classnames.bind(styles);

export interface IProps
{
    value?:string;
    label?:string;
    isUppercased?:boolean
}

export class SelectedValue extends React.Component<IProps>
{
    public render():JSX.Element
    {
        const {value, label, isUppercased} = this.props;

        return (
            <span className={cx(styles.base, {isUppercased})}>
				{value && <span className={styles.value}>{value}</span>}
                {label && <span className={styles.label}>{label}</span>}
			</span>
        );
    }
}

